import "styles/globals.css";

import { Provider } from "next-auth/client";

import * as Sentry from "@sentry/node";
import { Integrations } from "@sentry/tracing";

import Layout from "components/Layout";

Sentry.init({
  enabled: process.env.NODE_ENV === "production",
  environment: process.env.SENTRY_ENVIRONMENT || "development",
  dsn: process.env.SENTRY_DSN || "",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.2,
});

function MyApp({ Component, pageProps }) {
  if (pageProps.session) {
    const user = pageProps.session.user;
    Sentry.setUser({ email: user.email });
  }

  return (
    <Provider session={pageProps.session}>
      <Layout session={pageProps.session}>
        <Component {...pageProps} />
      </Layout>
    </Provider>
  );
}

export default MyApp;
